<script lang="ts">

  import { onMount } from "svelte"

  import { Button } from "$lib/components/ui/button"
  import { current } from "$lib/global-date"

  import type { Activity } from "../../_types"

  let {
    activity,
    disabled = false,
    handleSubmitStart,
    handleSubmitEnd,
  }: {
    activity?: Activity
    disabled?: boolean
    handleSubmitStart: () => void
    handleSubmitEnd: () => void
  } = $props()

  let now = $state(current())

  const currentTime = $derived(now.format("HH:mm:ss"))


  const started = $derived(activity?.real_start_datetime.toDateFormat("HH:mm:ss", "00:00:00") ?? "00:00:00")
  const ended = $derived(activity?.real_end_datetime.toDateFormat("HH:mm:ss", "00:00:00") ?? "00:00:00")
  const canStart = $derived(!disabled && !!activity && started === "00:00:00")
  const canEnd = $derived(!disabled && !!activity && started !== "00:00:00" && ended === "00:00:00")

  onMount(() => {
    const timer = setInterval(() => (now = current()), 1000)

    return () => clearInterval(timer)
  })

</script>

<div class="flex flex-1 flex-col items-center space-y-2">
  <div class="text-sm">Mulai</div>
  <Button
    type="button"
    class="rounded-full tabular-nums tracking-widest shadow-none"
    disabled={!canStart}
    onclick={handleSubmitStart}>
    {canStart ? currentTime : started}
  </Button>
</div>
<div class="flex flex-1 flex-col items-center space-y-2">
  <div class="text-sm">Selesai</div>
  <Button
    type="button"
    class="rounded-full tabular-nums tracking-widest shadow-none"
    disabled={!canEnd}
    onclick={handleSubmitEnd}>
    {ended === "00:00:00" ? currentTime : ended}
  </Button>
</div>
